module.exports = __webpack_public_path__ + "media/images/produkty-fb7ad7c984c4c2519c093d81c82fd43e.png";